import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const tableSubHeaderDefaultVariants = {
  "contentsType": "text-left",
  "state": "default",
  "showTopLine": true,
  "showBottomLine": true,
  "showRightLine": true
}
const tableSubHeaderCompoundVariants = [
  {
    "contentsType": [
      "expand",
      "collapse",
      "spacer",
      "checkbox"
    ],
    "css": {
      "rightLine": {
        "display": "none"
      }
    }
  }
]

const tableSubHeaderSlotNames = [
  [
    "root",
    "table-sub-header__root"
  ],
  [
    "container",
    "table-sub-header__container"
  ],
  [
    "itemWrapper",
    "table-sub-header__itemWrapper"
  ],
  [
    "headerLabelGroup",
    "table-sub-header__headerLabelGroup"
  ],
  [
    "headerLabel",
    "table-sub-header__headerLabel"
  ],
  [
    "sortButton",
    "table-sub-header__sortButton"
  ],
  [
    "topLine",
    "table-sub-header__topLine"
  ],
  [
    "bottomLine",
    "table-sub-header__bottomLine"
  ],
  [
    "rightLine",
    "table-sub-header__rightLine"
  ],
  [
    "sortingIndicator",
    "table-sub-header__sortingIndicator"
  ],
  [
    "sortingIndex",
    "table-sub-header__sortingIndex"
  ],
  [
    "tooltipIcon",
    "table-sub-header__tooltipIcon"
  ]
]
const tableSubHeaderSlotFns = /* @__PURE__ */ tableSubHeaderSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, tableSubHeaderDefaultVariants, getSlotCompoundVariant(tableSubHeaderCompoundVariants, slotName))])

const tableSubHeaderFn = memo((props = {}) => {
  return Object.fromEntries(tableSubHeaderSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const tableSubHeaderVariantKeys = [
  "contentsType",
  "state",
  "showTopLine",
  "showBottomLine",
  "showRightLine"
]
const getVariantProps = (variants) => ({ ...tableSubHeaderDefaultVariants, ...compact(variants) })

export const tableSubHeader = /* @__PURE__ */ Object.assign(tableSubHeaderFn, {
  __recipe__: false,
  __name__: 'tableSubHeader',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: tableSubHeaderVariantKeys,
  variantMap: {
  "contentsType": [
    "text-left",
    "text-right",
    "expand",
    "collapse",
    "spacer",
    "checkbox"
  ],
  "state": [
    "default",
    "hover"
  ],
  "showTopLine": [
    "true",
    "false"
  ],
  "showBottomLine": [
    "true",
    "false"
  ],
  "showRightLine": [
    "true",
    "false"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, tableSubHeaderVariantKeys)
  },
  getVariantProps
})